import { defineComponent, ref, computed } from 'vue-demi';
import { s as script$1 } from './OrError-331220bc.js';
import { s as script$2 } from './OrHint-262c8217.js';
import { s as script$3 } from './OrLabel-4abbce6e.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, withCtx, renderSlot, createTextVNode, toDisplayString, createCommentVNode, createElementVNode, withDirectives, vShow, createVNode } from 'vue';

var FormGroupDirection;
(function (FormGroupDirection) {
  FormGroupDirection["Vertical"] = "vertical";
  FormGroupDirection["Horizontal"] = "horizontal";
})(FormGroupDirection || (FormGroupDirection = {}));

const FormGroup = [
// Layout
'layout-column',
// Spacing
'gap-md md:gap-sm'];
const FormGroupContent = [
// Spacing
'gap-md md:gap-sm'];
const FormGroupContentDirections = {
  [FormGroupDirection.Vertical]: [
  // Layout
  'layout-column'],
  [FormGroupDirection.Horizontal]: [
  // Layout
  'layout-row']
};

var script = defineComponent({
  name: 'OrFormGroup',
  components: {
    OrError: script$1,
    OrHint: script$2,
    OrLabel: script$3
  },
  props: {
    direction: {
      type: String,
      default: () => FormGroupDirection.Vertical
    },
    label: {
      type: String,
      default: undefined
    },
    hint: {
      type: String,
      default: undefined
    },
    error: {
      type: [String, Boolean],
      default: undefined
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    // Refs & Styles
    const root = ref();
    const rootStyles = computed(() => ['or-form-group-v3', ...FormGroup]);
    const contentStyles = computed(() => [...FormGroupContent, ...FormGroupContentDirections[props.direction]]);
    return {
      root,
      rootStyles,
      contentStyles
    };
  }
});

function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_OrLabel = resolveComponent("OrLabel");
  const _component_OrHint = resolveComponent("OrHint");
  const _component_OrError = resolveComponent("OrError");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles)
  }, [_ctx.$slots.label || _ctx.$slots.addon || _ctx.label ? (openBlock(), createBlock(_component_OrLabel, {
    key: 0,
    variant: 'group',
    invalid: !!_ctx.error,
    required: _ctx.required,
    disabled: _ctx.disabled
  }, {
    addon: withCtx(() => [renderSlot(_ctx.$slots, "addon")]),
    default: withCtx(() => [renderSlot(_ctx.$slots, "label", {}, () => [createTextVNode(toDisplayString(_ctx.label), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["invalid", "required", "disabled"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    class: normalizeClass(_ctx.contentStyles)
  }, [renderSlot(_ctx.$slots, "default")], 2 /* CLASS */), _ctx.$slots.hint || _ctx.hint ? withDirectives((openBlock(), createBlock(_component_OrHint, {
    key: 1,
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [renderSlot(_ctx.$slots, "hint", {}, () => [createTextVNode(toDisplayString(_ctx.hint), 1 /* TEXT */)])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["disabled"])), [[vShow, !_ctx.error]]) : createCommentVNode("v-if", true), withDirectives(createVNode(_component_OrError, {
    disabled: _ctx.disabled
  }, {
    default: withCtx(() => [createTextVNode(toDisplayString(_ctx.error), 1 /* TEXT */)]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["disabled"]), [[vShow, typeof _ctx.error === 'string' && _ctx.error.length > 0]])], 2 /* CLASS */);
}

script.render = render;
script.__file = "src/components/or-form-group-v3/OrFormGroup.vue";

export { FormGroupDirection as F, script as s };
